import { INFORMATION_SOURCE } from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal, schemaId, schemaInteger } from '../../../utils/schema.utils';

export const RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit = z.object({
    abloesen: z.boolean().default(false),
    bic: z
        .string()
        .transform((val) => val?.toUpperCase())
        .nullish()
        .default(null), // TODO weitere validierung nötig
    createdAt: z.coerce.date().nullish(),
    datumErsteZahlung: z.coerce.date().nullish().default(null), // TODO - warum wird hier ein richtiges date verwendet
    datumLetzteRate: z.coerce.date().nullish().default(null),
    // TODO - warum wird hier ein richtiges date verwendet
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    glaeubiger: z.string().nullish().default(null),
    iban: z.string().nullish().default(null),
    // TODO weitere tests
    id: schemaId,
    kreditinstitut: z.string().nullish().default(null),
    kreditLaufzeit: schemaInteger.nullish().default(null),
    rateMonatlich: schemaBigDecimal.nullish().default(null),
    restschuld: schemaBigDecimal.nullish().default(null),
    schlussrate: schemaBigDecimal.nullish().default(null),
    source: z.nativeEnum(INFORMATION_SOURCE).optional().default(INFORMATION_SOURCE.FORMULAR),
    urspruenglicherKreditbetrag: schemaBigDecimal.nullish().default(null),
    zinssatz: schemaBigDecimal.nullish().default(null),
});
